import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { verifyPermission } from "helpers/permission";
import { ERROR_401 } from "config/errorPage";
import { useIaDataConfig } from "hooks/configs/ia-data/useIaDataConfig";
import { useIaDataToggle } from "hooks/configs/ia-data/useIaDataToggle";
import { useIaDataForm } from "hooks/configs/ia-data/useIaDataForm";
import ActivationToggle from "components/configs/ia-data/ActivationToggle";
import InstitutionNameField from "components/configs/ia-data/InstitutionNameField";
import KeywordsInput from "components/configs/ia-data/KeywordsInput";

const IaDataConf = ({ userPermissions }) => {
  const { t, ready } = useTranslation();
  const { isLoading, config } = useIaDataConfig();
  const [currentConfig, setCurrentConfig] = useState(config);

  useEffect(() => {
    if (config) {
      setCurrentConfig(config);
    }
  }, [config]);

  const {
    formData,
    errors,
    isSubmitting,
    updateQuery,
    submitForm,
  } = useIaDataForm(currentConfig);

  const { isToggling, handleToggle } = useIaDataToggle(
    currentConfig,
    setCurrentConfig
  );

  useEffect(() => {
    if (ready) {
      document.title = t("Satis client - Paramètre configuration des comités");
    }
  }, [ready, t]);

  if (!verifyPermission(userPermissions, "list-escalation-config")) {
    window.location.href = ERROR_401;
    return null;
  }

  if (!ready) return null;

  if (!verifyPermission(userPermissions, "update-escalation-config")) {
    return null;
  }

  if (isLoading) {
    return (
      <div className="kt-content kt-grid__item kt-grid__item--fluid">
        <div className="text-center p-4">Loading...</div>
      </div>
    );
  }

  const handleNameChange = (e) => {
    setCurrentConfig((prev) => ({ ...prev, name: e.target.value }));
  };

  const handleKeywordsChange = (newKeywords) => {
    updateQuery(newKeywords);
    setCurrentConfig((prev) => ({ ...prev, query: newKeywords }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitForm();
  };

  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader kt-grid__item" id="kt_subheader">
        <div className="kt-container kt-container--fluid">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">{t("Paramètre")}</h3>
            <span className="kt-subheader__separator kt-hidden" />
            <div className="kt-subheader__breadcrumbs">
              <a href="#link" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter" />
              </a>
              <span className="kt-subheader__breadcrumbs-separator" />
              <a href="#link" className="kt-subheader__breadcrumbs-link">
                {t("Configuration de données collectées")}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
        <div className="row">
          <div className="col">
            <div className="kt-portlet">
              <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                  <h3 className="kt-portlet__head-title">
                    {t("Configuration de la collecte des commentaires")}
                  </h3>
                </div>
              </div>

              <form method="POST" className="kt-form">
                <div className="kt-form kt-form--label-right">
                  <div className="kt-portlet__body">
                    <ActivationToggle
                      isActive={currentConfig?.actived === 1}
                      onToggle={handleToggle}
                      isToggling={isToggling}
                      t={t}
                    />

                    <InstitutionNameField
                      name={currentConfig?.name || ""}
                      onChange={handleNameChange}
                      error={errors.name}
                      t={t}
                    />

                    <KeywordsInput
                      keywords={formData.query}
                      onChange={handleKeywordsChange}
                      error={errors.query}
                      disabled={!currentConfig?.actived}
                      t={t}
                    />
                  </div>

                  <div className="kt-portlet__foot">
                    <div className="kt-form__actions text-right">
                      {!isSubmitting ? (
                        <button
                          type="submit"
                          onClick={handleSubmit}
                          className="btn btn-primary"
                          disabled={!currentConfig?.actived}
                        >
                          {t("Enregistrer")}
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light"
                          type="button"
                          disabled
                        >
                          {t("Chargement")}...
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userPermissions: state.user.user.permissions,
});

export default connect(mapStateToProps)(IaDataConf);
